import { cn } from 'src/shared/lib/utils';

interface TitleProps {
  text: string;
  className?: string;
}

export default function Title({ text, className }: TitleProps) {
  return <span className={cn('text-typography-darkgrey text-sm', className)}>{text}</span>;
}
